import script from "./AdminPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPanel.vue?vue&type=script&setup=true&lang=js"

import "./AdminPanel.vue?vue&type=style&index=0&id=73c6a216&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73c6a216"]])

export default __exports__